export const localizationMauMsg = {
  pt: {
    locale: 'pt-BR',
    header: {
      title: 'Uso do Plano',
      description:
        'Acompanhe os principais indicadores de desempenho da sua operação conversacional. Essa visão reúne dados do portal Blip, permitindo entender o volume de MAUs e de mensagens trafegadas.',
      learnMore: 'Saiba mais sobre os termos',
      modalContent: {
        title: 'Detalhamento dos Termos',
        description: '<strong>MAU (Monthly Active User)</strong>: Usuário Ativo Mensal único por chatbot principal (router). Ou seja, será contabilizado todo usuário que enviou ou recebeu qualquer tipo de mensagem, como texto, imagem, documento, vídeo, clique ou quick reply, dentro de um mesmo mês. Para fins de cálculo, cada chatbot principal/router equivale a um ponto de contabilização de MAUs. Assim, se um mesmo usuário interagir em dois chatbots principais/routers distintos (por exemplo, em dois números de WhatsApp diferentes da empresa), ele será contabilizado como dois MAUs.',
        alert: '<strong>Mensagens Trafegadas</strong>: quaisquer tipos de mensagens (texto, imagem, documento, clique, emoji, etc.) enviadas ou recebidas entre 00:00 e 23:59.',
        action: 'Entendido',
      },
      showMoreButton: 'Ver mais',
      tooltipText:
        'Usuários Ativos Mensalmente (MAUs) são aqueles que tiveram qualquer contato com o chatbot (por meio de um envio ativo ou não), ao menos uma vez no mês. Eles serão contabilizados uma vez. Mensagens (MSGs) correspondem ao total de mensagens trafegado no mês. Consideramos ativadores das métricas todo contato realizado via chatbot, o atendimento humano (via Blip desk) e as mensagens ativas.',
    },
    leftChart: {
      title: 'Consumo atual',
      labels: {
        miu: 'MAUs',
        msg: 'Mensagens trafegadas',
      },
      customLabels: {
        miu: 'MAUs',
        msg: 'Mensagens trafegadas',
      },
    },
    leftInfoPaper: {
      totalMiu: {
        description: 'Volume de MAUs do mês atual',
        tooltipText: 'MAU (Monthly Active User): Usuário Ativo Mensal',
      },
      totalMsg: {
        description: 'Volume de Mensagens trafegadas do mês atual',
      },
      topWeekNumberMsg: {
        label: '{0} semana',
        description: 'Semana do mês selecionado que teve o maior número de Mensagens trafegadas',
      },
    },
    rightChart: {
      period: '{startDate} a {endDate}',
      title: 'Consumo semanal de MAUs e Mensagens trafegadas',
      customLabels: { miu: 'MAUs', msg: 'Mensagens trafegadas' },
      warningLabel: {
        bold: 'Importante: ',
        regular:
          'Serão contabilizados os MAUs e MSGs do mês corrente. Após a aplicação de valores acordados em contrato, será cobrada a métrica de menor valor.',
      },
    },
    rightInfoPaper: {
      weeklyMiuAverage: {
        description: 'Média semanal de consumo de MAUs',
      },
      weeklyMsgAverage: {
        description: 'Média semanal de consumo de Mensagens trafegadas',
      },
      topWeekNumberMiu: {
        label: '{0} semana',
        description: 'Semana do mês selecionado que teve o maior número de MAUs',
      },
    },
  },
  en: {
    locale: 'en-US',
    header: {
      title: 'Plan Usage',
      description:
        'Track your conversational operation\'s key performance indicators. This view gathers data from the Blip portal, helping you understand the volume of MAUs and Exchanged messages.',
      learnMore: 'Learn more about the terms.',
      modalContent: {
        title: 'Detailed explanation of terms',
        description: '<strong>MAU (Monthly Active User)</strong>: Unique monthly active user per main chatbot (router). That is, every user who sent or received any type of message, such as text, image, document, video, click, or quick reply, within the same month will be counted. For counting purposes, each main chatbot/router counts as one MAU. Therefore, if the same user interacts with two different main chatbots/routers (for example, two different WhatsApp company numbers), they will be counted as two MAUs.',
        alert: '<strong>Exchanged Messages</strong>: Any type of message (text, image, document, click, emoji, etc.) sent or received between 00:00 and 23:59.',
        action: 'Close',
      },
      showMoreButton: 'See more',
      tooltipText:
        'Monthly Active Users (MAUs) are users who have had any contact with a chatbot (via active messages or not) at least once a month. They will be counted once. Messages (MSGs) correspond to the total number of messages exchanged in a month. Contacts made via chatbot, human service (Blip desk), and active messages are metrics activators.',
    },
    leftChart: {
      title: 'Current usage',
      labels: { miu: 'MAUs', msg: 'Exchanged messages' },
      customLabels: { miu: 'MAUs', msg: 'Exchanged messages' },
    },
    leftInfoPaper: {
      totalMiu: {
        description: 'Volume of MAUs in the current month',
        tooltipText: 'MAU (Monthly Active User)',
      },
      totalMsg: {
        description: 'Exchanged messages volume in the current month',
      },
      topWeekNumberMsg: {
        label: '{0} week',
        description: 'Week of the selected month with the highest number of Exchanged messages',
      },
    },
    rightChart: {
      period: '{startDate} to {endDate}',
      title: 'Weekly usage of MAUs and Messages exchanged',
      customLabels: { miu: 'MAUs', msg: 'Exchanged messages' },
      warningLabel: {
        bold: 'Important: ',
        regular:
          'MAUs and MSGs for the current month will be counted. After applying the agreed values, only the metric with the lowest value will be charged.',
      },
    },
    rightInfoPaper: {
      weeklyMiuAverage: {
        description: 'Weekly average usage of MAUs',
      },
      weeklyMsgAverage: {
        description: 'Weekly average usage of exchanged messages',
      },
      topWeekNumberMiu: {
        label: '{0} week',
        description: 'Week of the selected month with the highest number of MAUs',
      },
    },
  },
  es: {
    locale: 'es-ES',
    header: {
      title: 'Uso del Plan',
      description: 'Sigue los principales indicadores de rendimiento de tu operación conversacional. Esta vista reúne datos del portal Blip y te permite entender el volumen de MAU y de Mensajes intercambiados.',
      learnMore: 'Explicación detallada de los términos',
      modalContent: {
        title: 'Detailed explanation of terms',
        description: '<strong>MAU (Usuario Activo Mensual)</strong>: Usuario activo único por chatbot principal (router). Se contabilizará todo usuario que haya enviado o recibido cualquier tipo de mensaje, como texto, imagen, documento, video, clic o respuesta rápida, dentro del mismo mes. A efectos de cálculo, cada chatbot principal/router equivale a un MAU. Por lo tanto, si un mismo usuario interactúa con dos chatbots principales/routers distintos (por ejemplo, dos números de WhatsApp diferentes de la empresa), será contabilizado como dos MAUs.',
        alert: '<strong>Mensajes intercambiados</strong>: Cualquier tipo de mensaje (texto, imagen, documento, clic, emoji, etc.) enviado o recibido entre las 00:00 y las 23:59.',
        action: 'Cerrar',
      },
      showMoreButton: 'Ver más',
      tooltipText:
        'Los Usuarios Activos Mensuales (MAUs) son aquellos que han tenido algún contacto con el chatbot (a través de un mensaje activo o no) al menos una vez al mes. MAUs se contarán una vez. Mensajes (MSGs) corresponden al número total de mensajes intercambiadas en el mes. Son activadores de las métricas todos los contactos realizados a través de chatbot, servicio humano (vía Blip desk) y mensajes activos.',
    },
    leftChart: {
      title: 'Consumo actual',
      labels: { miu: 'MAUs', msg: 'Mensajes intercambiados' },
      customLabels: { miu: 'MAUs', msg: 'Mensajes intercambiados' },
    },
    leftInfoPaper: {
      totalMiu: {
        description: 'Volumen de MAUs del mes actual',
        tooltipText: 'MAU (Monthly Active User): Usuario Activo Mensual',
      },
      totalMsg: {
        description: 'Volumen de Mensajes intercambiados del mes actual ',
      },
      topWeekNumberMsg: {
        label: '{0} semana',
        description: 'Semana del mes seleccionado con el mayor número de Mensajes intercambiados',
      },
    },
    rightChart: {
      period: '{startDate} al {endDate}',
      title: 'Consumo semanal de MAUs y Mensajes intercambiados',
      customLabels: { miu: 'MAUs', msg: 'Mensajes intercambiados' },
      warningLabel: {
        bold: 'Importante: ',
        regular:
          'Se contarán MAUs y MSGs del mes en curso. Luego de la aplicación de los valores pactados en el contrato, se cobrará la métrica de menor valor.',
      },
    },
    rightInfoPaper: {
      weeklyMiuAverage: {
        description: 'Promedio semanal de consumo de MAUs',
      },
      weeklyMsgAverage: {
        description: 'Promedio semanal de consumo de mensajes intercambiados',
      },
      topWeekNumberMiu: {
        label: '{0} semana',
        description: 'Semana del mes seleccionado con mayor número de MAUs',
      },
    },
  },
};

export const localizationMeuMsg = {
  pt: {
    locale: 'pt-BR',
    header: {
      title: 'Uso do Plano',
      description:
        'Acompanhe os principais indicadores de desempenho da sua operação conversacional. Essa visão reúne dados do portal Blip, permitindo entender o volume de MEUs e de mensagens ativas.',
      learnMore: 'Saiba mais sobre os termos',
      modalContent: {
        title: 'Detalhamento dos Termos',
        description: '<strong>MEU (Monthly Engaged User)</strong>: Usuário Mensal Engajado único por chatbot principal (router). Será considerado como um MEU todo usuário distinto que se comunicou com algum chatbot de qualquer forma, seja respondendo ou enviando uma mensagem, clicando, ou realizando qualquer outro tipo de interação. Isso inclui qualquer usuário distinto que tenha enviado pelo menos uma mensagem ao chatbot, independentemente do tipo de mensagem (texto, imagem, documento, vídeo, áudio, clique em carrossel, quick reply, emoji ou cliques), em qualquer canal (como Whatsapp, RCS, Blip Chat). Para exemplificar, caso a empresa se comunique com o mesmo usuário distinto em dois números diferentes de WhatsApp no mesmo mês, serão contabilizados dois MEUs',
        alert: '<strong>Mensagens Ativas</strong>: quaisquer mensagens por disparo ativo enviadas pela empresa, independente do engajamento (interação ou resposta) do usuário final',
        action: 'Entendido',
      },
      showMoreButton: 'Ver mais',
      tooltipText:
        'Usuários Ativos Mensalmente (MEUs) são aqueles que entraram em contato com o chatbot ao menos uma vez no mês. MSGs (Mensagens) correspondem ao total de Mensagens trafegado no mês.',
    },
    leftChart: {
      title: 'Consumo atual',
      tooltipText:
        'O volume de MSGs usualmente será maior do que o de MEUs. Para a fatura, é o valor final que determinará qual volumetria será usada para a cobrança. Assim, o valor na fatura do plano será a volumetria do mês vezes o valor negociado por unidade, sendo cobrado o menor valor, seja ele correspondente a MEUs ou a Mensagens.',
      labels: {
        miu: 'MEUs',
        msg: 'Mensagens ativas',
      },
      customLabels: {
        miu: 'MEUs',
        msg: 'Mensagens ativas',
      },
    },
    leftInfoPaper: {
      totalMiu: {
        description: 'Volume de MEUs do mês atual',
        tooltipText: 'MEU (Monthly Engaged Users): Usuário Mensal Engajado',
      },
      totalMsg: {
        description: 'Volume de Mensagens ativas do mês atual',
      },
      topWeekNumberMsg: {
        label: '{0} semana',
        description: 'Semana do mês selecionado que teve o maior número de Mensagens ativas',
      },
    },
    rightChart: {
      period: '{startDate} a {endDate}',
      title: 'Consumo semanal de MEUs e Mensagens ativas',
      customLabels: {
        miu: 'MEUs consumidos',
        msg: 'Mensagens consumidas',
      },
      warningLabel: {
        bold: '',
        regular:
          'Um usuário ativo mensal será contabilizado uma única vez, a partir do seu primeiro contato com o chatbot no mês.',
      },
    },
    rightInfoPaper: {
      weeklyMiuAverage: {
        description: 'Média semanal de consumo de MEUs',
      },
      weeklyMsgAverage: {
        description: 'Média semanal de consumo de Mensagens ativas',
      },
      topWeekNumberMiu: {
        label: '{0} semana',
        description: 'Semana do mês selecionado que teve o maior número de MEUs',
      },
    },
  },
  en: {
    locale: 'en-US',
    header: {
      title: 'Plan Usage',
      description:
        'Track your conversational operation\'s key performance indicators. This view gathers data from the Blip portal, helping you understand the volume of MEUs and Exchanged messages.',
      learnMore: 'Learn more about the terms',
      modalContent: {
        title: 'Detailed explanation of terms',
        description: '<strong>MEU (Monthly Engaged User)</strong>: Unique monthly engaged user per main chatbot (router). Any single user who interacts with a chatbot in any way (whether by sending or responding to a message, clicking, or performing any other type of interaction) will be counted as an MEU. This includes any single user who has sent at least one message to the chatbot, regardless of message type (text, image, document, video, audio, carousel click, quick reply, emoji, or other clicks) and across any channel (such as WhatsApp, RCS, Blip Chat). For example, if a company communicates with the same user via two different WhatsApp numbers in the same month, they will be counted as two MEUs.',
        alert: '<strong>Proactive Messages</strong>: Any messages sent by the company through active dispatch, regardless of the end user’s engagement (interaction or response)',
        action: 'Close',
      },
      showMoreButton: 'See more',
      tooltipText:
        'Monthly Active Users (MEUs) are those who have contacted the chatbot at least once in a month. Messages (MSGs) are the total number of messages exchanged in a month.',
    },
    leftChart: {
      title: 'Message usage',
      tooltipText:
        'The volume of MSGs will usually be greater than the volume of MEUs. In the invoice, the final value will determine which volume will be considered for billing. The amount to be paid will be calculated as follows: the volume of the month times the amount negotiated per unit. The lower amount will be charged, be it related to MEUs or Messages.',
      labels: { miu: 'MEUs', msg: 'Proactive messages' },
      customLabels: { miu: 'MEUs', msg: 'Proactive messages' },
    },
    leftInfoPaper: {
      totalMiu: {
        description: 'Volume of MEUs in the current month',
        tooltipText: 'MEU (Monthly Engaged Users): Monthly Engaged User',
      },
      totalMsg: {
        description: 'Proactive messages volume in the current month',
      },
      topWeekNumberMsg: {
        label: '{0} week',
        description: 'Week of the selected month with the highest number of Proactive messages',
      },
    },
    rightChart: {
      period: '{startDate} to {endDate}',
      title: 'Weekly usage of MEUs and Proactive messages',
      customLabels: { miu: 'Usage of MEUs', msg: 'Counted messages' },
      warningLabel: {
        bold: '',
        regular:
          'A monthly active user will be counted only once, upon their first contact with the chatbot in a month.',
      },
    },
    rightInfoPaper: {
      weeklyMiuAverage: {
        description: 'Weekly average usage of MEUs',
      },
      weeklyMsgAverage: {
        description: 'Weekly average usage of Proactive messages',
      },
      topWeekNumberMiu: {
        label: '{0} week',
        description: 'Week of the selected month with the highest number of MEUs',
      },
    },
  },
  es: {
    locale: 'es-ES',
    header: {
      title: 'Uso del Plan',
      description: 'Sigue los principales indicadores de rendimiento de tu operación conversacional. Esta vista reúne datos del portal Blip y te permite entender el volumen de MEU y de Mensajes intercambiados.',
      learnMore: 'Obtén más información sobre estos términos',
      modalContent: {
        title: 'Explicación detallada de los términos',
        description: '<strong>MEU (Usuario Comprometido Mensual)</strong>: Usuario comprometido único por chatbot principal (router). Se considerará como MEU a cualquier usuario distinto que se haya comunicado con algún chatbot de cualquier forma, ya sea respondiendo o enviando un mensaje, haciendo clic, o realizando cualquier otro tipo de interacción. Esto incluye a cualquier usuario distinto que haya enviado al menos un mensaje al chatbot, independientemente del tipo de mensaje (texto, imagen, documento, video, audio, clic en carrusel, respuesta rápida, emoji u otros clics), y a través de cualquier canal (como WhatsApp, RCS, Blip Chat). Por ejemplo, si la empresa se comunica con el mismo usuario distinto en dos números diferentes de WhatsApp durante el mismo mes, se contabilizarán dos MEUs.',
        alert: '<strong>Mensajes Proactivos</strong>: Cualquier mensaje enviado mediante disparo activo por la empresa, independientemente del nivel de participación (interacción o respuesta) del usuario final.',
        action: 'Cerrar',
      },
      showMoreButton: 'Ver más',
      tooltipText:
        'Usuarios activos mensuales (MEUs) son aquellos que se han puesto en contacto con el chatbot al menos una vez al mes. Mensajes (MSG) corresponden al número total de mensajes intercambiados en un mes.',
    },
    leftChart: {
      title: 'Consumo de mensajes',
      labels: { miu: 'MEUs', msg: 'Mensajes proactivos' },
      customLabels: { miu: 'MEUs', msg: 'Mensajes proactivos' },
      tooltipText:
        'El volumen de MSG normalmente será mayor que el volumen de MEUs. En la factura, el valor final determinará qué volumen se considerará para la facturación. El monto a pagar se calculará de la siguiente manera: el volumen del mes por el monto negociado por unidad. Se cobrará el monto menor, ya sea relacionado con MAU o Mensajes.',
    },
    leftInfoPaper: {
      totalMiu: {
        description: 'Volumen de MEUs del mes actual',
        tooltipText: 'MEU (Monthly Engaged Users): Usuario Comprometido Mensual',
      },
      totalMsg: {
        description: 'Volumen de Mensajes proactivos del mes actual ',
      },
      topWeekNumberMsg: {
        label: '{0} semana',
        description: 'Semana del mes seleccionado con el mayor número de Mensajes proactivos',
      },
    },
    rightChart: {
      period: '{startDate} al {endDate}',
      title: 'Uso semanal de MEUs y Mensajes proactivos',
      customLabels: { miu: 'MEUs consumidos', msg: 'Mensajes consumidos' },
    },
    rightInfoPaper: {
      weeklyMiuAverage: {
        description: 'Promedio semanal de consumo de MEUs',
      },
      weeklyMsgAverage: {
        description: 'Promedio semanal de consumo de Mensajes proactivos',
      },
      topWeekNumberMiu: {
        label: '{0} semana',
        description: 'Semana del mes seleccionado con mayor número de MEUs',
      },
    },
  },
};

export const localizationMau = {
  pt: {
    locale: 'pt-BR',
    header: {
      title: 'Uso do Plano',
      description: 'Seu contrato registra o volume total de MAUs',
      showMoreButton: 'Ver mais',
      tooltipText:
        'Usuários Ativos Mensalmente (MAUS) são aqueles que tiveram qualquer contato com o chatbot (por meio de um envio ativo ou não), ao menos uma vez no mês. Eles serão contabilizados uma vez.',
    },
    leftChart: {
      title: 'Consumo atual',
      labels: {
        miu: 'MAUs',
      },
      customLabels: {
        miu: 'MAUs',
      },
    },
    leftInfoPaper: {
      totalMiu: {
        description: 'Volume de MAUs do mês atual',
      },
    },
    rightChart: {
      period: '{startDate} a {endDate}',
      title: 'Consumo semanal de MAUs',
      customLabels: {
        miu: 'MAUs consumidos',
      },
      warningLabel: {
        bold: 'Importante: ',
        regular:
          'Um usuário ativo mensal será contabilizado uma única vez, a partir da sua primeira conversa com o chatbot no mês, seja ela iniciada pelo usuário ou pelo chatbot (com o envio de mensagens ativas).',
      },
    },
    rightInfoPaper: {
      weeklyMiuAverage: {
        description: 'Média semanal de consumo de MAUs',
      },
      topWeekNumberMiu: {
        label: '{0} semana',
        description: 'Semana do mês selecionado que teve o maior número de MAUs',
      },
    },
  },
  en: {
    locale: 'en-US',
    header: {
      title: 'Plan Usage',
      description: 'Your contract records the total volume of MAUs.',
      showMoreButton: 'See more',
      tooltipText:
        'Monthly Active Users (MAUs) are users who have had any contact with a chatbot (via active messages or not) at least once a month. They will be counted once.',
    },
    leftChart: {
      title: 'Current usage',
      labels: {
        miu: 'MAUs',
      },
      customLabels: {
        miu: 'MAUs',
      },
    },
    leftInfoPaper: {
      totalMiu: {
        description: 'Volume of MAUs in the current month',
      },
    },
    rightChart: {
      period: '{startDate} to {endDate}',
      title: 'Weekly usage of MAUs',
      customLabels: {
        miu: 'Usage of MAUs',
      },
      warningLabel: {
        bold: 'Important: ',
        regular:
          'A MAU will be counted only once, upon the first contact with a chatbot in a month, be it initiated by the user or the chatbot (via active messages).',
      },
    },
    rightInfoPaper: {
      weeklyMiuAverage: {
        description: 'Weekly average usage of MAUs',
      },
      topWeekNumberMiu: {
        label: '{0} week',
        description: 'Week of the selected month with the highest number of MAUs',
      },
    },
  },
  es: {
    locale: 'es-ES',
    header: {
      title: 'Uso del Plan',
      description: 'Tu contrato registra el volumen total de MAUs.',
      showMoreButton: 'Ver más',
      tooltipText:
        'Los Usuarios Activos Mensuales (MAUs) son aquellos que han tenido algún contacto con el chatbot (a través de un mensaje activo o no) al menos una vez al mes. MAUs se contarán una vez.',
    },
    leftChart: {
      title: 'Consumo actual',
      labels: {
        miu: 'MAUs',
      },
      customLabels: {
        miu: 'MAUs',
      },
    },
    leftInfoPaper: {
      totalMiu: {
        description: 'Volumen de MAUs del mes actual',
      },
    },
    rightChart: {
      period: '{startDate} al {endDate}',
      title: 'Consumo semanal de MAUs',
      customLabels: {
        miu: 'MAUs consumidos',
      },
      warningLabel: {
        bold: 'Importante: ',
        regular:
          'Un MAU se contará solo una vez, en su primer contacto con el chatbot en un mes, ya sea iniciado por el usuario o por el chatbot (con el envío de mensajes activos).',
      },
    },
    rightInfoPaper: {
      weeklyMiuAverage: {
        description: 'Promedio semanal de consumo de MAUs',
      },
      topWeekNumberMiu: {
        label: '{0} semana',
        description: 'Semana del mes seleccionado con mayor número de MAUs',
      },
    },
  },
};

export const localizationMeu = {
  pt: {
    locale: 'pt-BR',
    header: {
      title: 'Uso do Plano',
      description:
        'Acompanhe os principais indicadores de desempenho da sua operação conversacional. Essa visão reúne dados do portal Blip, permitindo entender o volume de MEUs e de mensagens ativas.',
      learnMore: 'Saiba mais sobre os termos',
      modalContent: {
        title: 'Detalhamento dos Termos',
        description: '<strong>MEU (Monthly Engaged User)</strong>: Usuário Mensal Engajado único por chatbot principal (router). Será considerado como um MEU todo usuário distinto que se comunicou com algum chatbot de qualquer forma, seja respondendo ou enviando uma mensagem, clicando, ou realizando qualquer outro tipo de interação. Isso inclui qualquer usuário distinto que tenha enviado pelo menos uma mensagem ao chatbot, independentemente do tipo de mensagem (texto, imagem, documento, vídeo, áudio, clique em carrossel, quick reply, emoji ou cliques), em qualquer canal (como Whatsapp, RCS, Blip Chat). Para exemplificar, caso a empresa se comunique com o mesmo usuário distinto em dois números diferentes de WhatsApp no mesmo mês, serão contabilizados dois MEUs',
        alert: '<strong>Mensagens Ativas</strong>: quaisquer mensagens por disparo ativo enviadas pela empresa, independente do engajamento (interação ou resposta) do usuário final',
        action: 'Entendido',
      },
      showMoreButton: 'Ver mais',
      tooltipText:
        'Usuários Ativos Mensalmente (MEUs) são aqueles que entraram em contato com o chatbot ao menos uma vez no mês. MSGs (Mensagens) correspondem ao total de Mensagens trafegado no mês.',
    },
    leftChart: {
      title: 'Consumo atual',
      tooltipText:
        'O volume de MSGs usualmente será maior do que o de MEUs. Para a fatura, é o valor final que determinará qual volumetria será usada para a cobrança. Assim, o valor na fatura do plano será a volumetria do mês vezes o valor negociado por unidade, sendo cobrado o menor valor, seja ele correspondente a MEUs ou a Mensagens.',
      labels: {
        miu: 'MEUs',
        msg: 'Mensagens ativas',
      },
      customLabels: {
        miu: 'MEUs',
        msg: 'Mensagens ativas',
      },
    },
    leftInfoPaper: {
      totalMiu: {
        description: 'Volume de MEUs do mês atual',
        tooltipText: 'MEU (Monthly Engaged Users): Usuário Mensal Engajado',
      },
      totalMsg: {
        description: 'Volume de Mensagens ativas do mês atual',
      },
      topWeekNumberMsg: {
        label: '{0} semana',
        description: 'Semana do mês selecionado que teve o maior número de Mensagens ativas',
      },
    },
    rightChart: {
      period: '{startDate} a {endDate}',
      title: 'Consumo semanal de MEUs e Mensagens ativas',
      customLabels: {
        miu: 'MEUs consumidos',
        msg: 'Mensagens consumidas',
      },
      warningLabel: {
        bold: '',
        regular:
          'Um usuário ativo mensal será contabilizado uma única vez, a partir do seu primeiro contato com o chatbot no mês.',
      },
    },
    rightInfoPaper: {
      weeklyMiuAverage: {
        description: 'Média semanal de consumo de MEUs',
      },
      weeklyMsgAverage: {
        description: 'Média semanal de consumo de Mensagens ativas',
      },
      topWeekNumberMiu: {
        label: '{0} semana',
        description: 'Semana do mês selecionado que teve o maior número de MEUs',
      },
    },
  },
  en: {
    locale: 'en-US',
    header: {
      title: 'Plan Usage',
      description:
        'Track your conversational operation\'s key performance indicators. This view gathers data from the Blip portal, helping you understand the volume of MEUs and Exchanged messages.',
      learnMore: 'Learn more about the terms',
      modalContent: {
        title: 'Detailed explanation of terms',
        description: '<strong>MEU (Monthly Engaged User)</strong>: Unique monthly engaged user per main chatbot (router). Any single user who interacts with a chatbot in any way (whether by sending or responding to a message, clicking, or performing any other type of interaction) will be counted as an MEU. This includes any single user who has sent at least one message to the chatbot, regardless of message type (text, image, document, video, audio, carousel click, quick reply, emoji, or other clicks) and across any channel (such as WhatsApp, RCS, Blip Chat). For example, if a company communicates with the same user via two different WhatsApp numbers in the same month, they will be counted as two MEUs.',
        alert: '<strong>Proactive Messages</strong>: Any messages sent by the company through active dispatch, regardless of the end user’s engagement (interaction or response)',
        action: 'Close',
      },
      showMoreButton: 'See more',
      tooltipText:
        'Monthly Active Users (MEUs) are those who have contacted the chatbot at least once in a month. Messages (MSGs) are the total number of messages exchanged in a month.',
    },
    leftChart: {
      title: 'Message usage',
      tooltipText:
        'The volume of MSGs will usually be greater than the volume of MEUs. In the invoice, the final value will determine which volume will be considered for billing. The amount to be paid will be calculated as follows: the volume of the month times the amount negotiated per unit. The lower amount will be charged, be it related to MEUs or Messages.',
      labels: { miu: 'MEUs', msg: 'Proactive messages' },
      customLabels: { miu: 'MEUs', msg: 'Proactive messages' },
    },
    leftInfoPaper: {
      totalMiu: {
        description: 'Volume of MEUs in the current month',
        tooltipText: 'MEU (Monthly Engaged Users): Monthly Engaged User',
      },
      totalMsg: {
        description: 'Proactive messages volume in the current month',
      },
      topWeekNumberMsg: {
        label: '{0} week',
        description: 'Week of the selected month with the highest number of Proactive messages',
      },
    },
    rightChart: {
      period: '{startDate} to {endDate}',
      title: 'Weekly usage of MEUs and Proactive messages',
      customLabels: { miu: 'Usage of MEUs', msg: 'Counted messages' },
      warningLabel: {
        bold: '',
        regular:
          'A monthly active user will be counted only once, upon their first contact with the chatbot in a month.',
      },
    },
    rightInfoPaper: {
      weeklyMiuAverage: {
        description: 'Weekly average usage of MEUs',
      },
      weeklyMsgAverage: {
        description: 'Weekly average usage of Proactive messages',
      },
      topWeekNumberMiu: {
        label: '{0} week',
        description: 'Week of the selected month with the highest number of MEUs',
      },
    },
  },
  es: {
    locale: 'es-ES',
    header: {
      title: 'Uso del Plan',
      description: 'Sigue los principales indicadores de rendimiento de tu operación conversacional. Esta vista reúne datos del portal Blip y te permite entender el volumen de MEU y de Mensajes intercambiados.',
      learnMore: 'Obtén más información sobre estos términos',
      modalContent: {
        title: 'Explicación detallada de los términos',
        description: '<strong>MEU (Usuario Comprometido Mensual)</strong>: Usuario comprometido único por chatbot principal (router). Se considerará como MEU a cualquier usuario distinto que se haya comunicado con algún chatbot de cualquier forma, ya sea respondiendo o enviando un mensaje, haciendo clic, o realizando cualquier otro tipo de interacción. Esto incluye a cualquier usuario distinto que haya enviado al menos un mensaje al chatbot, independientemente del tipo de mensaje (texto, imagen, documento, video, audio, clic en carrusel, respuesta rápida, emoji u otros clics), y a través de cualquier canal (como WhatsApp, RCS, Blip Chat). Por ejemplo, si la empresa se comunica con el mismo usuario distinto en dos números diferentes de WhatsApp durante el mismo mes, se contabilizarán dos MEUs.',
        alert: '<strong>Mensajes Proactivos</strong>: Cualquier mensaje enviado mediante disparo activo por la empresa, independientemente del nivel de participación (interacción o respuesta) del usuario final.',
        action: 'Cerrar',
      },
      showMoreButton: 'Ver más',
      tooltipText:
        'Usuarios activos mensuales (MEUs) son aquellos que se han puesto en contacto con el chatbot al menos una vez al mes. Mensajes (MSG) corresponden al número total de mensajes intercambiados en un mes.',
    },
    leftChart: {
      title: 'Consumo de mensajes',
      labels: { miu: 'MEUs', msg: 'Mensajes proactivos' },
      customLabels: { miu: 'MEUs', msg: 'Mensajes proactivos' },
      tooltipText:
        'El volumen de MSG normalmente será mayor que el volumen de MEUs. En la factura, el valor final determinará qué volumen se considerará para la facturación. El monto a pagar se calculará de la siguiente manera: el volumen del mes por el monto negociado por unidad. Se cobrará el monto menor, ya sea relacionado con MAU o Mensajes.',
    },
    leftInfoPaper: {
      totalMiu: {
        description: 'Volumen de MEUs del mes actual',
        tooltipText: 'MEU (Monthly Engaged Users): Usuario Comprometido Mensual',
      },
      totalMsg: {
        description: 'Volumen de Mensajes proactivos del mes actual ',
      },
      topWeekNumberMsg: {
        label: '{0} semana',
        description: 'Semana del mes seleccionado con el mayor número de Mensajes proactivos',
      },
    },
    rightChart: {
      period: '{startDate} al {endDate}',
      title: 'Uso semanal de MEUs y Mensajes proactivos',
      customLabels: { miu: 'MEUs consumidos', msg: 'Mensajes consumidos' },
    },
    rightInfoPaper: {
      weeklyMiuAverage: {
        description: 'Promedio semanal de consumo de MEUs',
      },
      weeklyMsgAverage: {
        description: 'Promedio semanal de consumo de Mensajes proactivos',
      },
      topWeekNumberMiu: {
        label: '{0} semana',
        description: 'Semana del mes seleccionado con mayor número de MEUs',
      },
    },
  },
};

export const localizationMsg = {
  pt: {
    locale: 'pt-BR',
    header: {
      title: 'Mensagens',
      description: 'Seu contrato registra o volume total de Mensagens',
      showMoreButton: 'Ver mais',
      tooltipText: 'Mensagens (MSGs) correspondem ao total de mensagens trafegado no mês.',
    },
    leftChart: {
      title: 'Consumo atual',
      labels: {
        msg: 'Mensagens',
      },
      customLabels: {
        msg: 'Mensagens',
      },
    },
    leftInfoPaper: {
      totalMsg: {
        description: 'Volume de Mensagens do mês atual',
      },
      topWeekNumberMsg: {
        label: '{0} semana',
        description: 'Semana do mês selecionado que teve o maior número de Mensagens',
      },
    },
    rightChart: {
      period: '{startDate} a {endDate}',
      title: 'Consumo semanal de Mensagens',
      customLabels: {
        msg: 'Mensagens consumidas',
      },
      warningLabel: {
        bold: 'Importante: ',
        regular:
          'Todas as MSGs trafegadas no mês corrente serão contabilizadas. ',
      },
    },
    rightInfoPaper: {
      weeklyMsgAverage: {
        description: 'Média semanal de consumo de Mensagens',
      },
    },
  },
  en: {
    locale: 'en-US',
    header: {
      title: 'Messages',
      description: 'Your contract records the total volume of Messages.',
      showMoreButton: 'See more',
      tooltipText: 'Messages (MSGs) correspond to the total number of messages exchanged in a month.',
    },
    leftChart: {
      title: 'Current usage',
      labels: {
        msg: 'Messages',
      },
      customLabels: {
        msg: 'Messages',
      },
    },
    leftInfoPaper: {
      totalMsg: {
        description: 'Volume of messages in the current month',
      },
      topWeekNumberMsg: {
        label: '{0} week',
        description: 'Week of the selected month with the highest number of messages',
      },
    },
    rightChart: {
      period: '{startDate} to {endDate}',
      title: 'Weekly usage of Messages',
      customLabels: {
        msg: 'Counted messages',
      },
      warningLabel: {
        bold: 'Important: ',
        regular: 'All MSGs exchanged in the current month will be counted.',
      },
    },
    rightInfoPaper: {
      weeklyMsgAverage: {
        description: 'Weekly average usage of messages',
      },
    },
  },
  es: {
    locale: 'es-ES',
    header: {
      title: 'Mensajes',
      description: 'Tu contrato registra el volumen total de Mensajes.',
      showMoreButton: 'Ver más',
      tooltipText: 'Los mensajes (MSGs) corresponden al número total de mensajes intercambiados en un mes.',
    },
    leftChart: {
      title: 'Consumo actual',
      labels: {
        msg: 'Mensajes',
      },
      customLabels: {
        msg: 'Mensajes',
      },
    },
    leftInfoPaper: {
      totalMsg: {
        description: 'Volumen de mensajes del mes actual',
      },
      topWeekNumberMsg: {
        label: '{0} semana',
        description: 'Semana del mes seleccionado con el mayor numero de Mensajes',
      },
    },
    rightChart: {
      period: '{startDate} al {endDate}',
      title: 'Consumo semanal de Mensajes',
      customLabels: {
        msg: 'Mensajes consumidos',
      },
      warningLabel: {
        bold: 'Importante: ',
        regular: 'Se contarán todos los MSGs transmitidos en el mes actual.',
      },
    },
    rightInfoPaper: {
      weeklyMsgAverage: {
        description: 'Promedio semanal de consumo de mensajes',
      },
    },
  },
};
